module.exports = __webpack_public_path__ + "a978ae9dd195c2329289e0d10ae98309.pdf";